module.exports = __webpack_public_path__ + "img/hnjt1.d56880d9.jpg";